module.exports = __webpack_public_path__ + "img/person-ski-lift.f5544bd7.svg";